import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initFilter = storage.get('ddpsf');
const initSource = storage.get('ddsrc');

const initialState = {
  diamondFilter: initFilter ? JSON.parse(initFilter) : {},
  diamondResults: null,
  diamondResultsCount: 0,
  selectedDiamond: null,
  selectedList: [],
  lastResultsPosition: 0,
  resultsList: false,
  source: initSource ? initSource : 'store',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.DIAMONDS_FILTER_SAVE:
      return filterSave(state, action);
    case constants.DIAMONDS_SAVE:
      return diamondsSave(state, action);
    case constants.DIAMONDS_SAVE_SELECTED:
      return diamondsSaveSelected(state, action);
    case constants.DIAMONDS_SET_LAST_POSITION:
      return diamondsSetLastPosition(state, action);
    case constants.DIAMONDS_TOGGLE_LIST:
      return diamondsToggleList(state, action);
    case constants.DIAMONDS_SET_SOURCE:
      return diamondsSetSource(state, action);
	  default:
	    return state;
  }
}

function filterSave(state, action) {
  const newFilters = Object.assign({}, state, {
    diamondFilter: action.filters,
  });

  storage.put('ddpsf', JSON.stringify(newFilters.diamondFilter));
  return newFilters;
}

function diamondsSave(state, action) {
  return Object.assign({}, state, {
    diamondResults: action.diamonds,
    diamondResultsCount: action.count,
  });
}

function diamondsSaveSelected(state, action) {
  return Object.assign({}, state, {
    selectedList: action.diamonds,
  });
}

function diamondsSetLastPosition(state, action) {
  return Object.assign({}, state, {
    lastResultsPosition: action.scrollPos,
  });
}

function diamondsToggleList(state, action) {
  return Object.assign({}, state, {
    resultsList: !state.resultsList,
  });
}

function diamondsSetSource(state, action) {
  storage.put('ddsrc', action.code);
  return Object.assign({}, state, {
    source: action.code,
  });
}